// client/src/context/tasks/reducer.ts
import { COFFRET } from "../../api/coffrets";
import { actions } from "./actions";
import { InitialStateType } from "./store";

type ActionType = {
  type: string;
  payload?: any;
};

const toArray = <T,>(v: any): T[] => (Array.isArray(v) ? v : []);

export const reducer = (state: InitialStateType, action: ActionType): InitialStateType => {
  switch (action.type) {
    // 👉 on met à jour coffrets (pas une clé "tasks" inexistante)
    case actions.GET_TASKS:
    case actions.GET_COFFRETS:
      return { ...state, coffrets: toArray<COFFRET>(action.payload) };

    case actions.RESET_COFFRETS_TO_CSV:
      return { ...state, coffretsToCsv: [] };

    case actions.SET_COFFRETS_TO_CSV: {
      const idx = state.coffretsToCsv.findIndex(c => c?._id === action.payload?._id);
      if (idx < 0) {
        return { ...state, coffretsToCsv: [...state.coffretsToCsv, action.payload] };
      }
      const arr = [...state.coffretsToCsv];
      arr.splice(idx, 1);
      return { ...state, coffretsToCsv: arr };
    }

    case actions.GET_DATA:
      return { ...state, data: action.payload };

    case actions.SET_SEARCH:
      return {
        ...state,
        search: { ...state.search, [action.payload.searchName]: action.payload.value },
      };

    case actions.SET_IS_MODAL_OPEN:
      return { ...state, isModalOpen: !state.isModalOpen };

    case actions.SET_COFFRET_TO_UPDATE:
      return { ...state, coffretToUpdate: action.payload };

    default:
      return state;
  }
};